module.exports = __webpack_public_path__ + "img/月亮.419258ee.svg";